module.exports = __webpack_public_path__ + "media/assets/fonts/fselliotpro-bold-webfont-10fa8c2cb3305e5b9473a5d3573a2760.woff";